import axios from '../../utils/axiosConfig';
import { Contexture } from './Contexture';

const BASE_URL = `${process.env.REACT_APP_LAMBDA_API_URL}/contexture/rejected`;

export class Rejected {
  static async fetchAll(params) {
    try {
      const response = await axios.get(`${BASE_URL}`, {
        headers: Contexture.getHeaders(params.profileId),
        params,
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async fetchStateCounts(params) {
    try {
      const response = await axios.get(`${BASE_URL}/statecounts`, {
        headers: Contexture.getHeaders(params.profileId),
        params,
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async exportRejected(params) {
    try {
      const response = await axios.get(`${BASE_URL}/export`, {
        headers: Contexture.getHeaders(params.profileId),
        params,
        responseType: 'blob',
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async addDocument(documentId, params) {
    try {
      const response = await axios.post(`${BASE_URL}/${documentId}`, null, {
        headers: Contexture.getHeaders(params.profileId),
        params,
      });

      return response.status;
    } catch (err) {
      throw err;
    }
  }

  static async removeDocument(documentId, params) {
    try {
      const response = await axios.delete(`${BASE_URL}/${documentId}`, {
        headers: Contexture.getHeaders(params.profileId),
        params,
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async addTag(documentId, params) {
    try {
      const response = await axios.get(`${BASE_URL}/${documentId}/add_tag`, {
        headers: Contexture.getHeaders(params.profileId),
        params,
      });

      return response.status;
    } catch (err) {
      throw err;
    }
  }

  static async removeTag(documentId, params) {
    try {
      const response = await axios.get(`${BASE_URL}/${documentId}/remove_tag`, {
        headers: Contexture.getHeaders(params.profileId),
        params,
      });

      return response.status;
    } catch (err) {
      throw err;
    }
  }
}
